import { Helmet } from 'react-helmet-async';
import { TicketTemplatesPageContent } from '@starjack/widgets/ticketTemplates';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';

const TicketTemplates: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Ticketvorlagen | Starjack Admin</title>
            </Helmet>
            <TicketTemplatesPageContent />
        </>
    );
};

TicketTemplates.isProtected = true;
TicketTemplates.permissions = [Permission.MAIL_CONFIGURATION_NAV];
TicketTemplates.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

export default TicketTemplates;
